import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

import type {
  PostBoardReportsRequest,
  PostBoardReportsResponse,
} from '../types';

export const postBoardReports = async (request: PostBoardReportsRequest) => {
  const url = `/api/v2/boards/${request.boardId}/reports`;
  const { data } = await apiAuthClient.post<PostBoardReportsResponse>(
    url,
    request.body,
  );
  return data.data;
};
